import React, { Component } from 'react';
import { connect } from 'react-redux';
import ForgeView from '../../forgeView';
import Drawing from '../../drawing';
import { getActiveProject } from '../../../reducers/mainReducer';
import './StepReview.css';

export class StepReview extends Component {
    render() {
        const { showDrawing, onCloseDrawing } = this.props;

        return (
            <div className="step-review-layout">
                <div className="step-review-viewer">
                    {showDrawing ? (
                        <div className="step-review-drawing-view">
                            <div className="step-review-drawing-header">
                                <span>Drawing Preview</span>
                                <button
                                    className="step-review-close-btn"
                                    onClick={onCloseDrawing}
                                >
                                    Back to 3D View
                                </button>
                            </div>
                            <div className="step-review-drawing-content">
                                <Drawing />
                            </div>
                        </div>
                    ) : (
                        <ForgeView />
                    )}
                </div>
            </div>
        );
    }
}

/* istanbul ignore next */
export default connect(function(store) {
    return {
        activeProject: getActiveProject(store)
    };
})(StepReview);
